import { render, staticRenderFns } from "./OfficerMasterItems.vue?vue&type=template&id=123bb234"
import script from "./OfficerMasterItems.vue?vue&type=script&lang=js"
export * from "./OfficerMasterItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports